(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emergent-store-collection"]) return;
  try {
    
  if (!customElements.get('emergent-store-menu')) {
    customElements.define('emergent-store-menu', class extends HTMLElement {
      connectedCallback() {
        this.menu = this.querySelector('.emergent-store__menu');
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.sync = () => { this.menu.open = this.desktop.matches; };
        this.desktop.addEventListener('change', this.sync);
        this.sync();
      }
      disconnectedCallback() {
        this.desktop.removeEventListener('change', this.sync);
      }
    });
  }
  if (!customElements.get('emergent-store-sort')) {
    customElements.define('emergent-store-sort', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.form = this.querySelector('.emergent-store__sort');
        this.select = this.form?.querySelector('select[name="sort_by"]');
        this.button = this.form?.querySelector('button[type="submit"]');
        if (!this.select || !this.button || typeof HTMLFormElement.prototype.requestSubmit !== 'function') return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const sync = () => {
          const value = new URL(window.location.href).searchParams.get('sort_by') || 'manual';
          this.select.value = Array.from(this.select.options).some(option => option.value === value) ? value : 'manual';
        };
        this.select.addEventListener('change', () => HTMLFormElement.prototype.requestSubmit.call(this.form), options);
        this.form.addEventListener('submit', () => {
          this.form.querySelectorAll('[data-store-query-param]').forEach(input => input.remove());
          const existing = new Set(Array.from(this.form.elements).map(input => input.name));
          for (const [name, value] of new URL(window.location.href).searchParams) {
            if (existing.has(name) || ['page', 'sections', 'section_id'].includes(name)) continue;
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            input.dataset.storeQueryParam = '';
            this.form.appendChild(input);
          }
        }, options);
        window.addEventListener('pageshow', sync, options);
        sync();
        this.button.hidden = true;
      }
      disconnectedCallback() {
        this.events?.abort();
        if (this.button) this.button.hidden = false;
      }
    });
  }

if (!customElements.get('emergent-store-ranking')) {
  customElements.define('emergent-store-ranking', class extends HTMLElement {
    connectedCallback() {
      this.originalNodes = Array.from(this.querySelectorAll('#product-grid > li'));
      this.onPageHide = () => this.controller?.abort();
      this.onPageShow = event => { if (event.persisted) this.start(); };
      window.addEventListener('pagehide', this.onPageHide);
      window.addEventListener('pageshow', this.onPageShow);
      this.start();
    }
    disconnectedCallback() {
      this.controller?.abort();
      window.removeEventListener('pagehide', this.onPageHide);
      window.removeEventListener('pageshow', this.onPageShow);
    }
    number(value, minimum = 0) {
      if (!/^(0|[1-9]\d*)$/.test(value)) throw new Error('metadata');
      const number = Number(value);
      if (!Number.isSafeInteger(number) || number < minimum) throw new Error('metadata');
      return number;
    }
    metadata(element) {
      const data = element.dataset;
      return {
        count: this.number(data.storeCount),
        page: this.number(data.storePage, 1),
        pages: this.number(data.storePages),
        size: this.number(data.storePageSize, 1),
        offset: this.number(data.storeOffset),
        collection: data.storeCollection,
        section: data.storeSection,
        path: data.storePath,
        filters: data.storeFilterKey,
        sort: data.storeSort
      };
    }
    records(nodes, meta) {
      const expected = Math.max(0, Math.min(meta.size, meta.count - meta.offset));
      if (nodes.length !== expected) throw new Error('count');
      return nodes.map((node, index) => {
        const id = node.dataset.storeProductId;
        if (!/^[1-9]\d*$/.test(id || '')) throw new Error('identity');
        const tags = JSON.parse(node.dataset.storeFilterTags);
        const rankedTags = JSON.parse(node.dataset.storeRankTags);
        if (!Array.isArray(tags) || !tags.every(tag => typeof tag === 'string' && tag.length > 7 && tag.endsWith('-filter'))) throw new Error('tags');
        if (!Array.isArray(rankedTags)) throw new Error('weights');
        const weights = new Map();
        for (const tag of rankedTags) {
          const match = typeof tag === 'string' && /^(CPAP|Circuits|Accessories)-filter-(0|[1-9]\d{0,5})$/.exec(tag);
          if (!match || !tags.includes(match[1] + '-filter') || weights.has(match[1])) throw new Error('weights');
          weights.set(match[1], Number(match[2]));
        }
        return { id, node, weights, index: meta.offset + index };
      });
    }
    move(nodes) {
      const grid = this.querySelector('#product-grid');
      if (!grid) return;
      const focused = document.activeElement;
      for (let index = 0; index < nodes.length; index++) {
        const node = nodes[index], next = grid.children[index] || null;
        if (next === node) continue;
        if (grid.moveBefore) grid.moveBefore(node, next);
        else grid.insertBefore(node, next);
      }
      if (focused instanceof HTMLElement && focused.isConnected && document.activeElement !== focused) focused.focus({ preventScroll: true });
    }
    fallback(reason) {
      this.move(this.originalNodes);
      this.dataset.storeRankingState = 'fallback';
      this.dataset.storeRankingReason = reason;
      const status = this.querySelector('[data-store-ranking-status]');
      status.textContent = reason === 'pricing' ? this.dataset.storePricingMessage : this.dataset.storeFallbackMessage;
      status.hidden = false;
    }
    async fetchPage(page, initial, url, signal) {
      const request = new URL(url.href);
      request.searchParams.delete('section_id');
      request.searchParams.set('sections', initial.section);
      request.searchParams.set('page', String(page));
      const response = await fetch(request, {
        credentials: 'same-origin', cache: 'no-store', redirect: 'error', signal,
        headers: { Accept: 'application/json' }
      });
      if (!response.ok || response.url && new URL(response.url).origin !== url.origin) throw new Error('response');
      const payload = await response.json();
      if (!payload || typeof payload[initial.section] !== 'string' || !payload[initial.section].trim()) throw new Error('section');
      const doc = new DOMParser().parseFromString(payload[initial.section], 'text/html');
      const sections = Array.from(doc.querySelectorAll('emergent-store-ranking')).filter(node => node.dataset.storeSection === initial.section);
      if (sections.length !== 1) throw new Error('section');
      const element = sections[0], meta = this.metadata(element);
      for (const key of ['count', 'pages', 'size', 'collection', 'section', 'path', 'filters', 'sort']) {
        if (meta[key] !== initial[key]) throw new Error('inconsistent');
      }
      if (meta.page !== page || meta.offset !== (page - 1) * meta.size) throw new Error('page');
      return this.records(Array.from(element.querySelectorAll('#product-grid > li')), meta);
    }
    async complete(initial, initialRecords, url, signal) {
      const pages = Array.from({ length: initial.pages }, (_, index) => index + 1);
      const batches = new Map([[initial.page, initialRecords]]);
      const pending = pages.filter(page => page !== initial.page);
      let cursor = 0;
      await Promise.all(Array.from({ length: Math.min(3, pending.length) }, async () => {
        while (cursor < pending.length) {
          const page = pending[cursor++];
          batches.set(page, await this.fetchPage(page, initial, url, signal));
        }
      }));
      const records = pages.flatMap(page => batches.get(page));
      if (records.length !== initial.count || new Set(records.map(record => record.id)).size !== initial.count) throw new Error('incomplete');
      return records;
    }
    async start() {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      this.dataset.storeRankingState = 'native';
      const status = this.querySelector('[data-store-ranking-status]');
      status.hidden = true;
      let timeout;
      try {
        const url = new URL(window.location.href), initial = this.metadata(this);
        if (initial.sort !== 'manual' || url.searchParams.has('sort_by') && url.searchParams.get('sort_by') !== 'manual') return;
        const categories = JSON.parse(this.dataset.storeRankCategories);
        if (!Array.isArray(categories) || !categories.every(value => ['CPAP', 'Circuits', 'Accessories'].includes(value)) || new Set(categories).size !== categories.length) throw new Error('categories');
        if (categories.length === 0 || initial.count === 0) return;
        if (initial.count > 250 || initial.pages > 13 || initial.size !== 20) throw new Error('cap');
        if (initial.pages !== Math.ceil(initial.count / initial.size) || initial.page > initial.pages || initial.offset !== (initial.page - 1) * initial.size || initial.path !== url.pathname) throw new Error('pagination');
        const initialRecords = this.records(this.originalNodes, initial);
        this.dataset.storeRankingState = 'loading';
        timeout = setTimeout(() => controller.abort(), 12000);
        const records = await this.complete(initial, initialRecords, url, controller.signal);
        if (controller.signal.aborted || !this.isConnected || window.location.href !== url.href) return;
        const score = record => categories.reduce((sum, category) => sum + (record.weights.get(category) || 0), 0);
        records.sort((a, b) => score(b) - score(a) || a.index - b.index);
        const target = records.slice(initial.offset, initial.offset + initial.size);
        const originalById = new Map(initialRecords.map(record => [record.id, record.node]));
        if (target.some(record => !originalById.has(record.id))) throw new Error('pricing');
        this.move(target.map(record => originalById.get(record.id)));
        this.dataset.storeRankingState = 'ranked';
      } catch (error) {
        if (this.controller === controller && this.isConnected) this.fallback(error.message === 'pricing' ? 'pricing' : 'unavailable');
      } finally {
        clearTimeout(timeout);
        if (this.controller === controller) controller.abort();
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
